@if (filter) {
  <div>
    <mat-chip-listbox>
      <mat-chip (click)="switchSorting()"
        >Sort:
        @if (filter.Ascending) {
          <mat-icon>arrow_upwards</mat-icon>
        }
        @if (!filter.Ascending) {
          <mat-icon>arrow_downwards</mat-icon>
        }
      </mat-chip>
      @for (f of filter.Filters; track f) {
        @if (f.Type === filterTypes.CommunicationType) {
          <mat-chip-option (click)="removeFilter(f)" color="primary"
            >Type: {{ f.Keywords[0] }}
            <span class="close-chip">x</span></mat-chip-option
          >
        }
        @if (f.Type === filterTypes.Category) {
          <mat-chip-option (click)="removeFilter(f)" color="primary"
            >Cat.: {{ f.Keywords[0] }}
            <span class="close-chip">x</span></mat-chip-option
          >
        }
        @if (f.Type === filterTypes.Keywords) {
          <mat-chip (click)="removeFilter(f)" color="accent"
            >{{ f.Keywords.join(', ') }}
            <span class="close-chip">x</span></mat-chip
          >
        }
        @if (f.Type === filterTypes.Requestor) {
          <mat-chip (click)="removeFilter(f)" color="warn"
            >Contact: {{ f.Keywords.join(' ') }}
            <span class="close-chip">x</span></mat-chip
          >
        }
        @if (f.Type === filterTypes.Status) {
          <mat-chip (click)="removeFilter(f)"
            >Status: {{ f.Keywords.join(' or ') }}
            <span class="close-chip">x</span></mat-chip
          >
        }
        @if (f.Type === filterTypes.Reviewer) {
          <mat-chip (click)="removeFilter(f)"
            >Reviewer: {{ f.Keywords.join(' ') }}
            <span class="close-chip">x</span>
          </mat-chip>
        }
      }
    </mat-chip-listbox>
  </div>
}
